import { api } from "@/lib/api";

export function compressImage(file, maxSide = 1280, quality = 0.8) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("falha"))), "image/jpeg", quality);
    };
    img.onerror = () => reject(new Error("Imagem inválida"));
    img.src = url;
  });
}

export async function uploadPhoto(file, kind) {
  const blob = await compressImage(file);
  if (blob.size > 5 * 1024 * 1024) throw new Error("A foto deve ter no máximo 5 MB");
  const fd = new FormData();
  fd.append("file", blob, "foto.jpg");
  fd.append("kind", kind);
  const { data } = await api.post("/uploads", fd);
  return data.path;
}

let ctx = null;
const unlock = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
  } catch (e) {}
};
if (typeof window !== "undefined") ["pointerdown", "keydown", "touchstart"].forEach((ev) => window.addEventListener(ev, unlock, { once: true, passive: true }));

export function beep() {
  try {
    unlock();
    [0, 0.25, 0.5].forEach((t, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = i === 2 ? 1175 : 880;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.4, ctx.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.22);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.25);
    });
    if (navigator.vibrate) navigator.vibrate([300, 100, 300]);
  } catch (e) {}
}

function b64ToUint8(base64) {
  const pad = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

export async function enablePush(vapidKey) {
  if (!pushSupported()) throw new Error(isIOS() ? "No iPhone, instale o site na tela inicial primeiro." : "Seu navegador não suporta notificações.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permissão de notificação negada.");
  if (!vapidKey) throw new Error("Notificações ainda não configuradas no servidor.");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(vapidKey) });
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}
